import React, { useContext, useMemo } from 'react';

import { useSelector } from 'react-redux';
import SortIcon from '../../../../../../components/Table/SortIcon';
import { ServicesReportsContext } from '../../..';
import { getSortColumnByName } from '../../../../../../utils/helper';
import { REPORTS_SERVICES_SORT } from '../../../reducer/actionTypes';
import Tooltip from '../../../../../../components/Tooltip';
import { reportsSelector } from '../../../../../../redux/selectors/reports';

const ServicesTableHeader = () => {
  const reports = useSelector((state) => reportsSelector(state));
  const { pageConfig } = reports;

  const [componentStore, dispatchComponent] = useContext(ServicesReportsContext);
  const { sort, filters } = componentStore;

  const sortOrders = useMemo(() => getSortColumnByName(sort.columns, 'count_orders'), [sort.columns])
  const sortProfit = useMemo(() => getSortColumnByName(sort.columns, 'profit'), [sort.columns])
  const sortCharge = useMemo(() => getSortColumnByName(sort.columns, 'charge'), [sort.columns])
  const sortCost = useMemo(() => getSortColumnByName(sort.columns, 'cost'), [sort.columns])
  const sortRefunded = useMemo(() => getSortColumnByName(sort.columns, 'refunded'), [sort.columns])

  const activeDateFilterTitle = useMemo(() => {
    if (filters.range === 'custom') {
      return `from ${filters.date_from} to ${filters.date_to}`;
    }
    const activeFilter = pageConfig?.filters?.date_range_filter?.find((item) => item.code === filters.range);
    return activeFilter?.title ? activeFilter?.title.toLowerCase() : 'custom range';
  }, [filters, pageConfig])

  const onChangeSort = (sortColumn) => {
    const column = sortColumn.name;
    const active = sortColumn.active ? (sortColumn.active === 'desc' ? 'asc' : 'desc') : 'desc';
    dispatchComponent({ type: REPORTS_SERVICES_SORT, payload: { column, active } })
  }

  return (
    <div className="reports-services-table__header">
      <table>
        <thead>
          <tr>
            <th className="reports-services-table__header-id">ID</th>
            <th className="reports-services-table__header-name">Service</th>
            <th className="reports-services-table__header-cost">
              <button
                onClick={() => onChangeSort(sortOrders)}
                className="reports-services-table__header-sort-btn"
              >
                Orders
                {' '}
                <SortIcon sortObj={sortOrders} />
              </button>
            </th>
            <th className="reports-services-table__header-cost">
              <button
                onClick={() => onChangeSort(sortCharge)}
                className="reports-services-table__header-sort-btn"
              >
                Charge
                {' '}
                <SortIcon sortObj={sortCharge} />
              </button>
            </th>
            <th className="reports-services-table__header-cost">
              <button
                onClick={() => onChangeSort(sortCost)}
                className="reports-services-table__header-sort-btn"
              >
                Cost
                {' '}
                <SortIcon sortObj={sortCost} />
              </button>
            </th>
            <th className="reports-services-table__header-cost">
              <button
                onClick={() => onChangeSort(sortProfit)}
                className="reports-services-table__header-sort-btn"
              >
                Profit
                {' '}
                <SortIcon sortObj={sortProfit} />
              </button>
            </th>
            <th className="reports-services-table__header-cost">
              <button
                onClick={() => onChangeSort(sortRefunded)}
                className="reports-services-table__header-sort-btn"
              >
                Refunded
                {' '}
                <SortIcon sortObj={sortRefunded} />
              </button>
              <Tooltip text={`Total refunds to users for Canceled and Partial orders created ${activeDateFilterTitle}`}>
                <span className="fas fa-info-circle cursor-help" />
              </Tooltip>
            </th>
          </tr>
        </thead>
      </table>
    </div>
  )
}

ServicesTableHeader.propTypes = {};

export default ServicesTableHeader;
